import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { LuUser2 } from "react-icons/lu";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { ACADEMIC_YEAR, CONTEXT_COMMON_NAME } from "../CommonUtilities/Validations/RegularExpAndVar";
import { useEffect, useRef, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
function Header() {
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  function logout() {
    dispatch({ type: "SHOW_LOGIN_DETAILS", payload: {} });
    window.sessionStorage.removeItem('token');
    Cookies.remove("token")
    Cookies.remove("refreshToken")
    localStorage.clear()
    navigate("/")
  }
  const timerRef = useRef(null)
  const calculateTimeLeft = (expiry) => Math.max(0, expiry - Date.now());
  const formatTime = (ms) => {
    const totalSec = Math.floor(ms / 1000);
    const hrs = String(Math.floor(totalSec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
    const secs = String(totalSec % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };
  const Sweetalert = window.Sweetalert || (() => { });

  const refreshToken = Cookies.get("refreshToken");
  let refreshExpiry = 0;
  if (refreshToken) {
    try {
      refreshExpiry = jwtDecode(refreshToken).exp * 1000; // expiry in ms
    } catch (err) {
      refreshExpiry = 0;
    }
  }
  const [timeLeft, setTimeLeft] = useState('--:--');
  const [progress, setProgress] = useState(100);
  const [initialDuration, setInitialDuration] = useState(() => {
    const stored = localStorage.getItem("refreshTokenDuration");
    return stored ? Number(stored) :
      (refreshExpiry ? refreshExpiry - Date.now() : 0);
  });

  // const startTimer = () => {
  //   if (timerRef.current) {
  //     clearInterval(timerRef.current);
  //     timerRef.current = null;
  //   }
  //   const storedExpiry =
  //     Number(localStorage.getItem("refreshTokenExpiry")) ||
  //     refreshExpiry;
  //   if (!storedExpiry) {
  //     setProgress(0);
  //     setTimeLeft("--:--");
  //     return;
  //   }
  //   const updateTimer = () => {
  //     const remaining = calculateTimeLeft(storedExpiry);
  //     setTimeLeft(formatTime(remaining));
  //     const newProgress = initialDuration > 0 ? Math.max(0, Math.min(100, (remaining / initialDuration) * 100)): 0;
  //     setProgress(newProgress);
  //     if (remaining <= 0) {
  //       clearInterval(timerRef.current); // stop timer
  //       Swal.fire({
  //         title: "Session Expired",
  //         text: "Your session has expired. Please log in again.",
  //         icon: "warning",
  //         confirmButtonText: "OK",
  //         allowOutsideClick: false,
  //         allowEscapeKey: false
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           logout();
  //           localStorage.removeItem("refreshTokenDuration");
  //           localStorage.removeItem("refreshTokenExpiry");
  //         }
  //       });
  //     }
  //   };
  //   updateTimer();
  //   timerRef.current = setInterval(updateTimer, 1000);
  // };
  useEffect(() => {
    if (!refreshExpiry) {
      setTimeLeft("--:--");
      setProgress(0);
      return;
    }

    const totalDuration =
      Number(localStorage.getItem("refreshTokenDuration")) ||
      (refreshExpiry - Date.now());

    const updateTimer = () => {
      const remaining = Math.max(0, refreshExpiry - Date.now());

      setTimeLeft(formatTime(remaining));

      const progressPercent =
        totalDuration > 0
          ? Math.max(0, Math.min(100, (remaining / totalDuration) * 100))
          : 0;

      setProgress(progressPercent);

      if (remaining <= 0) {
        clearInterval(timerRef.current);

        Swal.fire({
          title: "Session Expired",
          text: "Your session has expired. Please log in again.",
          icon: "warning",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          logout();
          localStorage.removeItem("refreshTokenExpiry");
          localStorage.removeItem("refreshTokenDuration");
        });
      }
    };

    updateTimer();

    timerRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [refreshExpiry]);
  // useEffect(() => {
  //   const startTimer = () => {
  //     const expiry = Number(localStorage.getItem("refreshTokenExpiry"));
  //     console.log("expiry>>", expiry)
  //     if (!expiry) {
  //       setTimeLeft("--:--");
  //       setProgress(0);
  //       return;
  //     }
  //     const totalDuration = expiry - Date.now();
  //     const updateTimer = () => {
  //       const remaining = Math.max(0, expiry - Date.now());
  //       console.log("remaining>>>", remaining)
  //       setTimeLeft(formatTime(remaining));
  //       const progressPercent =
  //         totalDuration > 0 ? Math.max(0, (remaining / totalDuration) * 100) : 0;
  //       setProgress(progressPercent);
  //       if (remaining <= 0) {
  //         clearInterval(timerRef.current);
  //         Swal.fire({
  //           title: "Session Expired",
  //           text: "Your session has expired. Please log in again.",
  //           icon: "warning",
  //           confirmButtonText: "OK",
  //           allowOutsideClick: false,
  //         }).then(() => {
  //           logout();
  //           localStorage.removeItem("refreshTokenExpiry");
  //         });
  //       }
  //     };
  //     updateTimer();
  //     timerRef.current = setInterval(updateTimer, 1000);
  //   };
  //   startTimer();
  //   return () => {
  //     if (timerRef.current) clearInterval(timerRef.current);
  //   };
  // }, []);

  function redirectToPage() {
    if (!loginreducer || Object.keys(loginreducer).length === 0) {
      Sweetalert("Your session has expired", "warning")
      navigate("/", { screen: "HomeScreen" });
    }
  }
  // useEffect(() => { redirectToPage(); });
  useEffect(() => {
    redirectToPage();
  }, [loginreducer]);

  useEffect(() => {
    if (refreshExpiry) {
      const duration = refreshExpiry - Date.now();
      const storedDuration = localStorage.getItem("refreshTokenDuration");
      const storedExpiry = localStorage.getItem("refreshTokenExpiry");
      if (!storedDuration || !storedExpiry || Number(storedExpiry) !== refreshExpiry) {
        localStorage.setItem("refreshTokenDuration", duration.toString());
        localStorage.setItem("refreshTokenExpiry", refreshExpiry.toString());
        setInitialDuration(duration);
      }
    } else {
      localStorage.removeItem("refreshTokenDuration");
      localStorage.removeItem("refreshTokenExpiry");
      setInitialDuration(0);
      setProgress(0);
      setTimeLeft("--:--");
    }
  }, [refreshExpiry]);
  // useEffect(() => {
  //   startTimer();
  //   return () => { if (timerRef.current) clearInterval(timerRef.current); }
  // }, [initialDuration]);

  return (
    <Navbar expand="lg" className="nav-bg">
      <Container fluid>
        <Navbar.Brand href="#home" className="navbar-brand text-white">{CONTEXT_COMMON_NAME} - {ACADEMIC_YEAR}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />

        <Navbar.Collapse id="basic-navbar-nav">
          {/* <Nav className="ms-auto">
            <div className="user-icon-box">
            
              <LuUser2 className="user-icon-top" />
            </div>
            <NavDropdown title={`Welcome : ${loginreducer?.applicant_name || loginreducer?.officer_name} (${loginreducer?.username})`} id="basic-nav-dropdown" className="user-login">
              {loginreducer?.role_id === 2 && (<>
                <NavDropdown.Item onClick={() => { navigate('/ChangePassword') }} >Change Password</NavDropdown.Item>
                <NavDropdown.Item onClick={() => { navigate('/ProfilePage') }}>Profile</NavDropdown.Item>
              </>)}
              <NavDropdown.Item onClick={() => { logout() }}>LogOut</NavDropdown.Item>
            </NavDropdown>
          </Nav> */}
          <Nav className="ms-auto">
            <div className="session-timer-container" style={{ '--progress': progress }}>
              <div className="timer-box">
                <style> {`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }}`} </style>
                <span
                  className="timer-icon"
                  style={{
                    display: "inline-block",
                    animation: "spin 1s linear infinite",
                    transformOrigin: "center"
                  }}>⏳</span>
                <span className="timer-text" style={{ color: "white", marginLeft: '6px' }}>
                  {timeLeft}
                </span>
              </div>
              <div className="progress-bar-container pt-1 px-1">
                <div className="progress-bar " style={{ width: `${progress}%`, height: '6px', backgroundColor: '#00ff90', borderRadius: '4px', transition: 'width 0.5s linear' }} />
              </div>
            </div>
            <div className="user-icon-box">
              <LuUser2 className="user-icon-top" />
            </div>
            <NavDropdown title={`Welcome : ${loginreducer?.applicant_name || loginreducer?.officer_name} (${loginreducer?.username})`} id="basic-nav-dropdown" className="user-login">
              {loginreducer?.role_id === 2 && (<>
                <NavDropdown.Item onClick={() => { navigate('/ChangePassword') }} >Change Password</NavDropdown.Item>
                <NavDropdown.Item onClick={() => { navigate('/ProfilePage') }}>Profile</NavDropdown.Item>
              </>)}
              <NavDropdown.Item onClick={() => { logout() }}>LogOut</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
